import React from "react";
import Icon from "components/MainApp/atoms/Icon/icon";
import styles from "./LocationSummary.module.scss";
import i18n from "i18n";

const LocationSummary = ({ item, handleDelete }) => {
    return (
        <div>
            {item.items.map((itemData) => {
                return (
                    <div className={styles["location-summary-container"]}>
                        <div className={styles["location-summary-left"]}>
                            <div className={styles["path"]}>{itemData.tag}</div>
                            {item.dispatch_area && (
                                <div className={styles["items"]}>{i18n.t("new.departure.order")}</div>
                            )}
                             {/*<div className={styles["items"]}>{i18n.t("products")}({item.items.length})</div>  */}
                        </div>
                        <div className={styles["location-summary-right"]}>
                            <div className={styles["path"]}>{item.title}</div>
                            {handleDelete && (
                                <div onClick={() => handleDelete(item, itemData.tag)}>
                                    <Icon name="trash_can" width={20} height={20} fill={"#3C7AF5"} />
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default LocationSummary;